//sports-mvc naming convention to sports-api naming convention
const toReal = {
    date: 'date',
    rightsholder: 'rightsholder',
    sponsor: 'sponsor',
    placement: 'rightsholderPlacement',
    placementType: 'placementType',
    socialPlatform: 'socialPlatform',
    postType: 'postType',
    accountOwnershipType: 'accountOwnershipType',
    collection: 'collection',
    mediaType: 'mediaType',
    account: 'account',
    broadcast: 'mediaUploadName',
    game: 'gameName',
    country: 'country',
};

//sports-api naming convention to sports-mvc naming convention
const toFake = {
    date: 'date',
    rightsholder: 'rightsholder',
    sponsor: 'sponsor',
    rightsholderPlacement: 'placement',
    placementType: 'placementType',
    socialPlatform: 'socialPlatform',
    postType: 'postType',
    accountOwnershipType: 'accountOwnershipType',
    collection: 'collection',
    mediaType: 'mediaType',
    account: 'account',
    mediaUploadName: 'broadcast',
    gameName: 'game',
    country: 'country',
};

export default { toReal, toFake };
